import { createContext } from 'react'

export const FormLayoutContext = createContext({ editing: false })

export const FormLayoutProvider = ({ children, ...props }) => (
  <FormLayoutContext.Provider {...props}>{children}</FormLayoutContext.Provider>
)
